// Build ID injected by Vite at build time (see vite.config.ts).
declare const __BUILD_ID__: string;

export const BUILD_ID: string =
  typeof __BUILD_ID__ !== "undefined" ? __BUILD_ID__ : "dev";

export function shortBuildId(): string {
  // 20260530001530 -> 05/30 00:15
  if (!/^\d{14}$/.test(BUILD_ID)) return BUILD_ID;
  const mm = BUILD_ID.slice(4, 6);
  const dd = BUILD_ID.slice(6, 8);
  const hh = BUILD_ID.slice(8, 10);
  const mi = BUILD_ID.slice(10, 12);
  return `${mm}/${dd} ${hh}:${mi}`;
}
